export default (api) => ({
  actions: {
      create (store, payload) {
         return api.create(payload)
          .then(response => response.data)
      },
      update (store, payload) {
        return api.update(payload.id, payload)
          .then(response => response.data)
      },
      delete (store, id) {
        return api.delete(id)
          .then(response => response.data)
      },
      getById: function (store, id) {
        return api.getById(id)
          .then(response => response.data)
      },
    },
  })
